var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 5.11039C12.3227 4.93583 11.9155 4.97015 11.6042 5.20014L6.79912 8.74935H3.62979C2.73105 8.74935 2 9.48157 2 10.3817V14.7618C2 15.662 2.73105 16.3942 3.62979 16.3942H6.79912L11.6042 19.9434C11.7834 20.0761 11.9949 20.1434 12.2077 20.1434C12.3642 20.1434 12.5217 20.1071 12.6676 20.0328C13.0126 19.8583 13.227 19.5095 13.227 19.1221V6.02079C13.227 5.63373 13.0126 5.28462 12.6676 5.11006L12.668 5.11039ZM3.01866 14.7618V10.3817C3.01866 10.0442 3.29277 9.76963 3.62979 9.76963H6.45748V15.3739H3.62979C3.29277 15.3739 3.01866 15.0994 3.01866 14.7618ZM12.2084 19.1221L7.47581 15.6264V9.5172L12.2087 6.02112V19.1224L12.2084 19.1221Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0314 9.76593C14.7951 9.61315 14.4799 9.68113 14.3273 9.91772C14.1748 10.1543 14.2427 10.4701 14.4789 10.6229C15.1427 11.0522 15.539 11.7808 15.539 12.5714C15.539 13.362 15.1427 14.0903 14.4789 14.5199C14.2427 14.6727 14.1748 14.9884 14.3273 15.225C14.4248 15.3762 14.5886 15.4583 14.7556 15.4583C14.8502 15.4583 14.946 15.4319 15.0314 15.3768C15.9868 14.7585 16.5574 13.7098 16.5574 12.5714C16.5574 11.433 15.9868 10.384 15.0314 9.76593Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.382 12.5717C19.382 10.4688 18.3285 8.53119 16.5636 7.38849C16.3274 7.23538 16.0121 7.30336 15.8596 7.53995C15.7067 7.77654 15.7746 8.09233 16.0108 8.24511C17.4841 9.19906 18.3634 10.8166 18.3634 12.5717C18.3634 14.3269 17.4837 15.9444 16.0108 16.8984C15.7746 17.0511 15.7067 17.3669 15.8596 17.6035C15.9571 17.7547 16.1205 17.8368 16.2878 17.8368C16.3824 17.8368 16.4783 17.8104 16.5639 17.755C18.3288 16.6123 19.3824 14.6747 19.3824 12.5717H19.382Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9839 5.18514C17.7476 5.03203 17.4324 5.10001 17.2798 5.33627C17.127 5.57286 17.1948 5.88864 17.4307 6.04142C19.6542 7.48176 20.9815 9.92259 20.9815 12.5713C20.9815 15.22 19.6542 17.6608 17.4307 19.1008C17.1945 19.2539 17.127 19.5697 17.2798 19.806C17.3773 19.9568 17.5407 20.039 17.7078 20.039C17.8027 20.039 17.8982 20.0126 17.9839 19.9571C20.4986 18.3284 21.9999 15.5668 21.9999 12.571C21.9999 9.57512 20.4986 6.81389 17.9839 5.18514Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeHigh);
export default __webpack_public_path__ + "static/media/Volume-High.fe9d41c86e86a5ff60cb8b5f977fd7d1.svg";
export { ForwardRef as ReactComponent };